import React from 'react';

import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import {
  IconButton,
  Stack,
} from '@mui/material';

import Button from '../Button';

interface NavigatorProps {
  onNavigateForward: () => void,
  onNavigateBackward: () => void,
  onNavigateDefault: () => void,
  defaultText?: string,
  forwardDisabled?: boolean,
  backwardDisabled?: boolean,
  defaultDisabled?: boolean,
}

const Navigator = ({
  onNavigateForward,
  onNavigateBackward,
  onNavigateDefault,
  defaultText = 'Return',
  forwardDisabled = false,
  backwardDisabled = false,
  defaultDisabled = false,
}: NavigatorProps) => (
  <Stack direction="row" spacing={1} alignItems="center">
    <Button
      color="gray"
      onClick={onNavigateDefault}
      size="small"
      disabled={defaultDisabled}
    >
      {defaultText}
    </Button>
    <Stack
      direction="row"
      alignItems="center"
    >
      <IconButton onClick={onNavigateBackward} disabled={backwardDisabled}>
        <ChevronLeft />
      </IconButton>
      <IconButton onClick={onNavigateForward} disabled={forwardDisabled}>
        <ChevronRight />
      </IconButton>
    </Stack>
  </Stack>
);

export default Navigator;
